import network from '@/services/network';
import { ApiResponse } from '@/types';
import { ErrorResponse } from '@/utils';

export interface BookingConfig {
  self_duration_minutes: number;
  /**
   * Buchungshorizont = Spiegelhorizont (Entscheid Alex 14.09.2026,
   * `booking.horizon_days`). `horizon_until` ist der letzte buchbare Tag
   * (`YYYY-MM-DD`, Berliner Kalendertag) — der Fall-Dialog klemmt daran seine
   * Datumsauswahl. Optional, damit ein aelterer Server nicht bricht.
   */
  horizon_days?: number;
  horizon_until?: string;
}

const getConfig = async (): Promise<ApiResponse<BookingConfig>> => {
  try {
    const { data } = await network.get<ApiResponse<BookingConfig>>('/booking/config');
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const bookingApi = {
  getConfig,
};

export default bookingApi;
